import { Flame, ShieldCheck, Sparkles } from "lucide-react";

const WhoWeHelp = () => {
  return (
    <section id="who-we-help" data-testid="who-we-help" className="py-24 md:py-32 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: The story */}
          <div>
            <p
              className="text-xs tracking-[0.3em] uppercase mb-6"
              style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}
            >
              Does This Sound Like You?
            </p>
            <h2
              className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.15] mb-8"
              style={{ color: "var(--ll-text)" }}
            >
              Burnout Recovery for Women
              <br />
              <em className="italic" style={{ color: "var(--ll-text-secondary)" }}>
                Who Are Running on Empty
              </em>
            </h2>

            <div className="space-y-5">
              {[
                "You wake up already exhausted, dreading the day ahead.",
                "You've lost the spark that used to drive you — everything feels like a chore.",
                "You're snapping at people you love and withdrawing from friends.",
                "You know something needs to change, but you don't know where to start.",
              ].map((line) => (
                <div key={line} className="flex items-start gap-3">
                  <div className="w-1.5 h-1.5 rounded-full mt-2 flex-shrink-0" style={{ background: "var(--ll-accent)" }} />
                  <p className="text-base leading-relaxed" style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}>
                    {line}
                  </p>
                </div>
              ))}
            </div>

            <p
              className="text-base leading-relaxed mt-8 font-medium"
              style={{ color: "var(--ll-text)", fontFamily: "'Outfit', sans-serif" }}
            >
              You're not broken. You're burnt out. And there's a way back.
            </p>
          </div>

          {/* Right: The transformation */}
          <div className="space-y-6">
            {[
              {
                icon: Flame,
                label: "Where You Are",
                title: "Burnout & Overwhelm",
                text: "Constantly exhausted, disconnected from your purpose, feeling stuck in a cycle of overwork and under-living.",
                bgColor: "rgba(232,124,124,0.06)",
                borderColor: "rgba(232,124,124,0.15)",
                iconColor: "#e87c7c",
              },
              {
                icon: ShieldCheck,
                label: "The Bridge",
                title: "The Lemon Framework™",
                text: "Our evidence-informed approach combines self-awareness, emotional intelligence, and practical tools — designed specifically for women professionals.",
                bgColor: "rgba(247,208,70,0.08)",
                borderColor: "rgba(247,208,70,0.2)",
                iconColor: "var(--ll-accent)",
              },
              {
                icon: Sparkles,
                label: "Where You're Going",
                title: "Balance & Wellness",
                text: "Waking up with energy, setting boundaries that stick, reconnecting with joy, and building a life that doesn't require recovery from itself.",
                bgColor: "rgba(163,184,153,0.1)",
                borderColor: "rgba(163,184,153,0.25)",
                iconColor: "var(--ll-green)",
              },
            ].map((step) => (
              <div
                key={step.title}
                className="p-6 rounded-2xl transition-all duration-500 hover:-translate-y-0.5"
                style={{ background: step.bgColor, border: `1px solid ${step.borderColor}` }}
              >
                <div className="flex items-center gap-3 mb-3">
                  <step.icon size={18} style={{ color: step.iconColor }} />
                  <span
                    className="text-[10px] tracking-[0.2em] uppercase font-medium"
                    style={{ color: step.iconColor, fontFamily: "'Outfit', sans-serif" }}
                  >
                    {step.label}
                  </span>
                </div>
                <h3
                  className="font-serif text-lg font-medium mb-1"
                  style={{ color: "var(--ll-text)" }}
                >
                  {step.title}
                </h3>
                <p
                  className="text-sm leading-relaxed"
                  style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}
                >
                  {step.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeHelp;
